import React, { useState } from 'react';
import { Button, Form, FormControl, InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import './index.css';
import { IoMdAdd } from 'react-icons/io';
import { IoAddOutline, IoAlertCircle, IoAlertCircleOutline, IoInformationCircleOutline, IoSyncOutline } from 'react-icons/io5';
import PartyModal from '../../modals/party';
import PropertiesModal from '../../modals/properties';
import { ToWords } from 'to-words';
import { format } from 'date-fns';

function BookingForm({ bookingID, setBookingData, bookingData, setSelectedPayments, setInputError, inputError }) {

  const toWords = new ToWords();

  const [enableNotes, setEnableNotes] = useState(false);

  function handleChange(e) {
    const { id, value } = e.target;
    setInputError({ ...inputError, [id]: '' });
    setBookingData((prevData) => {
      return { ...prevData, [id]: value };
    });
  }

  function handlePartyResponse(data) {
    if (data) {
      setBookingData((prevData) => {
        return {
          ...prevData,
          partyDetails: data
        }
      });
    } else {
      setBookingData((prevData) => {
        return {
          ...prevData,
          partyDetails: null
        }
      });
    }
  }

  function handlePropertyResponse(data, tempBasicAmount, tempAdditionalCharges, selectedPayments) {
    if (data && tempBasicAmount) {
      setBookingData((prevData) => {
        return {
          ...prevData,
          projectDetails: data,
          basicAmount: tempBasicAmount,
          discountPercent: 0,
          discountAmount: 0,
          additionalCharges: tempAdditionalCharges
        }
      });

      setSelectedPayments(selectedPayments);
    }
  }

  function handleDiscountInPercent(e) {
    const { value } = e.target;
    const tempSubTotal = parseFloat(bookingData.basicAmount ? bookingData.basicAmount : 0) + parseFloat(bookingData.additionalCharges ? bookingData.additionalCharges : 0);
    var tempDiscountAmount = (parseFloat(value) / 100) * parseFloat(tempSubTotal);
    setBookingData((prevData) => {
      return {
        ...prevData,
        discountPercent: value,
        discountAmount: tempDiscountAmount ? tempDiscountAmount.toFixed(2) : 0
      }
    });
  }

  function handleDiscountInAmount(e) {
    const { value } = e.target;
    const tempSubTotal = parseFloat(bookingData.basicAmount ? bookingData.basicAmount : 0) + parseFloat(bookingData.additionalCharges ? bookingData.additionalCharges : 0);
    var tempDiscountPercent = (parseFloat(value) / parseFloat(tempSubTotal)) * 100;
    setBookingData((prevData) => {
      return {
        ...prevData,
        discountPercent: tempDiscountPercent ? tempDiscountPercent.toFixed(2) : 0,
        discountAmount: value
      }
    });
  }

  function handleTaxRate(e) {
    const { value } = e.target;
    setBookingData((prevData) => {
      return {
        ...prevData,
        taxRate: value
      }
    });
  }

  const SubTotal = parseFloat(bookingData.basicAmount ? bookingData.basicAmount : 0) + parseFloat(bookingData.additionalCharges ? bookingData.additionalCharges : 0);
  const TaxableAmount = parseFloat(SubTotal ? SubTotal : 0) - parseFloat(bookingData.discountAmount ? bookingData.discountAmount : 0);
  const TaxAmount = (parseFloat(TaxableAmount) * parseFloat(bookingData.taxRate)) / 100;
  const TotalAmount = parseFloat(TaxableAmount ? TaxableAmount : 0) + parseFloat(TaxAmount ? TaxAmount : 0);
  const AmountInWords = toWords.convert(TotalAmount ? TotalAmount : 0, { currency: true });

  return (
    <div className='form-wrapper p-3'>
      <Form>
        <div className='row'>
          <div className='col-md-8 col-12'>
            {
              bookingData && bookingData.partyDetails ?
                <>
                  <div className='d-flex align-items-center justify-content-between mb-2 pb-1'>
                    <h5 className='mb-0'>Party Details *</h5>
                    <PartyModal
                      title="Add Party"
                      buttonTitle={
                        <div className='d-flex align-items-center justify-content-center'>
                          <IoSyncOutline size={20} />
                          <h6 className='mb-0 ms-2'>Change</h6>
                        </div>
                      }
                      buttonVariant='outline-primary'
                      buttonClass='px-3'
                      buttonSize='sm'
                      handleResponse={handlePartyResponse}
                    />
                  </div>
                  <div className='card shadow-none border border-radius p-3'>
                    <div className='row'>
                      <div className='col-md-6'>
                        <div className='row'>
                          <div className='col-md-12'>
                            <Form.Group className="mb-3" controlId="partyName">
                              <Form.Label>Party Name *</Form.Label>
                              <h6 className='fw-600'>{bookingData.partyDetails.partyName}</h6>
                            </Form.Group>
                          </div>
                          <div className='col-md-12'>
                            <Form.Group className="mb-3">
                              <Form.Label className='mb-1'>Father/Husband *</Form.Label>
                              <p className='mb-0'>{bookingData.partyDetails.fatherHusband}</p>
                            </Form.Group>
                          </div>
                          <div className='col-md-12'>
                            <Form.Group controlId="phoneNumber">
                              <Form.Label className='mb-1'>Phone Number *</Form.Label>
                              <p className='mb-0'>+91 {bookingData.partyDetails.phoneNumber}</p>
                            </Form.Group>
                          </div>
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <Form.Group className="mb-3" controlId="partyAddress">
                          <Form.Label>Address *</Form.Label>
                          <p className='mb-1'>{bookingData.partyDetails.address}</p>
                          <p className='mb-1'>{bookingData.partyDetails.city ? bookingData.partyDetails.city : ''}{bookingData.partyDetails.pincode ? ', ' + bookingData.partyDetails.pincode : ''}{bookingData.partyDetails.state ? ', ' + bookingData.partyDetails.state : ''}</p>
                        </Form.Group>
                        <Form.Group controlId="partyNationality">
                          <Form.Label>State *</Form.Label>
                          <p className='mb-0'>{bookingData.partyDetails.state ? bookingData.partyDetails.state : '-'}</p>
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </>
                :
                <>
                  <h5 className='mb-2 pb-1'>Party Details *</h5>
                  <div className='card shadow-none'>
                    <PartyModal
                      title="Add Party"
                      buttonTitle={
                        <div className='d-flex align-items-center justify-content-center'>
                          <IoMdAdd size={20} color='var(--bs-primary)' />
                          <h6 className='mb-0 ms-2 text-primary'>Add Party</h6>
                        </div>
                      }
                      buttonVariant='white'
                      buttonClass="w-100 py-5 border-long-dashed rounded border-0 shadow-none"
                      handleResponse={handlePartyResponse}
                    />
                  </div>
                </>
            }
          </div>
          <div className='col-md-4 col-12'>
            <div className='row'>
              <div className='col-md-12'>
                <Form.Group className="mb-3" controlId="bookingID">
                  <Form.Label>Booking ID *</Form.Label>
                  <Form.Control
                    disabled
                    type="text"
                    placeholder='Enter booking ID'
                    className={inputError && inputError.bookingID ? 'border-danger' : ''}
                    value={bookingID ? bookingID : ''}
                    isInvalid={inputError && inputError.bookingID}
                  />
                  <Form.Control.Feedback type="invalid">{inputError && inputError.bookingID}</Form.Control.Feedback>
                </Form.Group>
              </div>
              <div className='col-md-6'>
                <Form.Group className="mb-3" controlId="physicalFileNumber">
                  <Form.Label>File No.</Form.Label>
                  <InputGroup className="mb-3">
                    <Form.Control
                      type="text"
                      onChange={handleChange}
                      placeholder='Enter file number'
                      value={bookingData.physicalFileNumber}
                    />
                    <InputGroup.Text>
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip>
                            <small>
                              A file number is used for a physical file to provide a unique identifier that makes it simple to identify document inside an organization.
                            </small>
                          </Tooltip>
                        }
                      >
                        <div>
                          <IoInformationCircleOutline size={16} color='var(--muted)' />
                        </div>
                      </OverlayTrigger>
                    </InputGroup.Text>
                  </InputGroup>
                </Form.Group>
              </div>
              <div className='col-md-6'>
                <Form.Group className="mb-3" controlId="referenceID">
                  <Form.Label>Reference ID No.</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={handleChange}
                    placeholder='Enter reference ID'
                    value={bookingData.referenceID}
                  />
                </Form.Group>
              </div>
              <div className='col-md-12'>
                <Form.Group className="mb-3" controlId="bookingDate">
                  <Form.Label>Booking Date *</Form.Label>
                  <Form.Control
                    type="date"
                    onChange={(event) => setBookingData({ ...bookingData, bookingDate: new Date(event.target.value) })}
                    className={inputError && inputError.bookingDate ? 'border-danger' : ''}
                    value={bookingData && bookingData.bookingDate ? format(bookingData.bookingDate, 'yyyy-MM-dd') : ''}
                    isInvalid={inputError && inputError.bookingDate}
                  />
                  <Form.Control.Feedback type="invalid">{inputError && inputError.bookingDate}</Form.Control.Feedback>
                </Form.Group>
              </div>
            </div>
          </div>
        </div>
        <div className='mb-5 mt-3'>
          <div className='d-flex align-items-center justify-content-between mb-2 pb-1'>
            <h5 className='mb-0'>Property Details *</h5>
            {
              bookingData && bookingData.projectDetails ?
                <PropertiesModal
                  title="Select Property"
                  buttonTitle={
                    <div className='d-flex align-items-center justify-content-center'>
                      <IoSyncOutline size={20} />
                      <h6 className='mb-0 ms-2'>Change</h6>
                    </div>
                  }
                  buttonVariant='outline-primary'
                  buttonClass='shadow-sm px-3'
                  buttonSize='sm'
                  handleResponse={handlePropertyResponse}
                />
                :
                null
            }
          </div>
          <div className='p-3 border-top border-start border-end rounded-top'>
            {
              bookingData && bookingData.projectDetails ?
                <div className='row'>
                  <div className='col-9 px-3'>
                    <span className='fw-600 text-capitalize'>{bookingData && bookingData.projectDetails && bookingData.projectDetails.propName}</span>
                    <h6 className='text-muted'>
                      <small>
                        <span>{bookingData && bookingData.projectDetails && bookingData.projectDetails.propLocality},</span>
                        <span> {bookingData && bookingData.projectDetails && bookingData.projectDetails.propCity},</span>
                        <span> {bookingData && bookingData.projectDetails && bookingData.projectDetails.propState}</span>
                      </small>
                    </h6>
                  </div>
                  <div className='col-3 px-3 text-end'>
                    <h6 className='mb-0'>
                      <small className='px-2'>
                        <span className='text-muted'>Tower - </span>
                        <span className='fw-600 text-capitalize'>{bookingData && bookingData.projectDetails && bookingData.projectDetails.bookedUnit && bookingData.projectDetails.bookedUnit.unitTower.name},</span>
                        <span className='text-muted ps-1'>Floor - </span>
                        <span className='fw-600'>{bookingData && bookingData.projectDetails && bookingData.projectDetails.bookedUnit && bookingData.projectDetails.bookedUnit.unitFloor}</span>
                      </small>
                    </h6>
                    <h6 className='mb-0'>
                      <small className='px-2'>
                        <span className='text-muted'>Unit Number - </span>
                        <span className='fw-600'>{bookingData && bookingData.projectDetails && bookingData.projectDetails.bookedUnit && bookingData.projectDetails.bookedUnit.unitNumber}</span>
                      </small>
                    </h6>
                  </div>
                </div>
                :
                null
            }
          </div>
          <div className='border-bottom border-start border-end rounded-bottom'>
            <div className='row px-4'>
              <div className='col-4 bg-light text-muted px-3 py-2'><small>Unit Name</small></div>
              <div className='col-2 bg-light text-muted text-center px-3 py-2'><small>Area</small></div>
              <div className='col-3 bg-light text-muted text-center px-3 py-2'><small>Basic Price</small></div>
              <div className='col-3 bg-light text-muted text-end px-3 py-2'><small>Amount</small></div>
            </div>
            {
              bookingData && bookingData.projectDetails ?
                <div className='row mb-2 px-4'>
                  <div className='col-4 px-3 py-2'>{bookingData && bookingData.projectDetails && bookingData.projectDetails.bookedUnit && bookingData.projectDetails.bookedUnit.unitName}</div>
                  <div className='col-2 text-center px-3 py-2'>{bookingData && bookingData.projectDetails && bookingData.projectDetails.bookedUnit && bookingData.projectDetails.bookedUnit.unitArea} {bookingData && bookingData.projectDetails && bookingData.projectDetails.propUnitMeasure}</div>
                  <div className='col-3 text-center px-3 py-2'>{parseFloat(bookingData && bookingData.projectDetails && bookingData.projectDetails.bookedUnit && bookingData.projectDetails.bookedUnit.unitbasicPrice).toLocaleString("en-US", { style: "currency", currency: "INR" })}</div>
                  <div className='col-3 text-end px-3 py-2'>{(parseFloat(bookingData && bookingData.projectDetails && bookingData.projectDetails.bookedUnit && bookingData.projectDetails.bookedUnit.unitbasicPrice) * parseFloat(bookingData && bookingData.projectDetails && bookingData.projectDetails.bookedUnit && bookingData.projectDetails.bookedUnit.unitArea)).toLocaleString("en-US", { style: "currency", currency: "INR" })}</div>
                </div>
                :
                null
            }
            {
              bookingData.projectDetails && bookingData.projectDetails.bookedUnit && bookingData.projectDetails.bookedUnit.unitAdditionalCharges && bookingData.projectDetails.bookedUnit.unitAdditionalCharges.length > 0 ?
                <div className='my-3'>
                  <div className='row px-4'>
                    <div className='col-6 bg-light text-muted px-3 py-2'><small>Additional Charges</small></div>
                    <div className='col-3 bg-light text-muted text-center px-3 py-2'><small>Rate</small></div>
                    <div className='col-3 bg-light text-muted text-center px-3 py-2'></div>
                  </div>
                  {
                    bookingData.projectDetails.bookedUnit.unitAdditionalCharges.map((charge, i) => {
                      return (
                        <div key={i} className='row px-4'>
                          <div className='col-6 px-3 py-2'>{charge.name}</div>
                          <div className='col-3 text-center px-3 py-2'>{parseFloat(charge.amount).toLocaleString("en-US", { style: "currency", currency: "INR" })}{charge.type === 'per' ? '/' + bookingData.projectDetails.propUnitMeasure : null}</div>
                          <div className='col-3 text-end px-3 py-2'>{charge.type === 'per' ? (parseFloat(charge.amount) * parseFloat(bookingData.projectDetails.bookedUnit.unitArea)).toLocaleString("en-US", { style: "currency", currency: "INR" }) : parseFloat(charge.amount).toLocaleString("en-US", { style: "currency", currency: "INR" })}</div>
                        </div>
                      )
                    })
                  }
                </div>
                :
                null
            }
            {
              bookingData && bookingData.projectDetails ?
                null
                :
                <div className='m-3'>
                  <PropertiesModal
                    title="Select Property"
                    buttonTitle={
                      <div className='d-flex align-items-center justify-content-center'>
                        <IoMdAdd size={20} color='var(--bs-primary)' />
                        <h6 className='mb-0 ms-2 text-primary'>Add Property</h6>
                      </div>
                    }
                    buttonVariant='white'
                    buttonClass='w-100 py-3 border-long-dashed rounded border-0 shadow-none'
                    buttonSize='sm'
                    handleResponse={handlePropertyResponse}
                  />
                </div>
            }
          </div>
        </div>
        <div className='row my-3'>
          <div className='col-md-6'>
            <div className='bg-white rounded border h-100 p-3'>
              {
                enableNotes && enableNotes ?
                  <Form.Group>
                    <Form.Label>Notes</Form.Label>
                    <FormControl
                      as="textarea"
                      rows={5}
                      placeholder='Enter your notes...'
                      onChange={(event) => setBookingData(prevData => {
                        return {
                          ...prevData,
                          note: event.target.value
                        }
                      })}
                    />
                  </Form.Group>
                  :
                  <Button
                    variant="outline-primary"
                    size='sm'
                    className='px-4 shadow-none border-0 bg-content'
                    onClick={() => setEnableNotes(true)}
                  >
                    <IoAddOutline size={18} />
                    Add Note
                  </Button>
              }

              <div className='mt-3'>
                <Form.Group>
                  <Form.Label>Terms and Conditions</Form.Label>
                  <FormControl
                    as="textarea"
                    rows={5}
                    placeholder='Enter terms and conditions'
                    onChange={(event) => setBookingData(prevData => {
                      return {
                        ...prevData,
                        termsConditions: event.target.value
                      }
                    })}
                    value={bookingData && bookingData.termsConditions}
                  />
                </Form.Group>
              </div>
            </div>
          </div>
          <div className='col-md-6'>
            <div className='card shadow-none border p-3'>
              <div className='d-flex align-items-center justify-content-between'>
                <h6 className='fw-bold'>
                  Sub Total
                </h6>
                <h6 className='fw-bold'>
                  {parseFloat(SubTotal).toLocaleString("en-US", { style: "currency", currency: "INR" })}
                </h6>
              </div>
              <div className='mt-2 d-flex align-items-center justify-content-between'>
                <h6 className='mb-0'>
                  Discount
                </h6>
                <div className='d-flex align-items-center justify-content-end'>
                  <div className='col-4'>
                    <Form.Group>
                      <InputGroup>
                        <InputGroup.Text className='py-1'>%</InputGroup.Text>
                        <Form.Control
                          placeholder='0'
                          className='py-0 border-left-0 text-end'
                          onFocus={e => e.target.select()}
                          onChange={handleDiscountInPercent}
                          value={bookingData.discountPercent}
                        />
                      </InputGroup>
                    </Form.Group>
                  </div>
                  <span className='px-2'>/</span>
                  <div className='col-4'>
                    <Form.Group>
                      <InputGroup>
                        <InputGroup.Text className='py-1'>₹</InputGroup.Text>
                        <Form.Control
                          placeholder='0'
                          className='py-0 border-left-0 text-end'
                          onFocus={e => e.target.select()}
                          onChange={handleDiscountInAmount}
                          value={bookingData.discountAmount}
                        />
                      </InputGroup>
                    </Form.Group>
                  </div>
                </div>
              </div>
              <div className='mt-3 d-flex align-items-center justify-content-between'>
                <h6 className='mt-2'>
                  Taxable Value
                </h6>
                <h6 className='mt-2'>
                  {parseFloat(TaxableAmount).toLocaleString("en-US", { style: "currency", currency: "INR" })}
                </h6>
              </div>
              <div className='mt-2 d-flex align-items-center justify-content-between'>
                <h6 className='mb-0'>
                  Tax Rate
                </h6>
                <div className='tax-rate'>
                  <InputGroup>
                    <InputGroup.Text className='py-1'>GST @</InputGroup.Text>
                    <Form.Select
                      value={bookingData.taxRate}
                      className='py-0 border-left-0'
                      onChange={handleTaxRate}
                    >
                      <option value={'0'}>0%</option>
                      <option value={'1'}>1%</option>
                      <option value={'5'}>5%</option>
                      <option value={'8'}>8%</option>
                      <option value={'12'}>12%</option>
                    </Form.Select>
                  </InputGroup>
                </div>
              </div>
              {
                bookingData && bookingData.partyDetails && bookingData.projectDetails && bookingData.partyDetails.state !== bookingData.projectDetails.propState ?
                  <div className='mt-2'>
                    <div className='row'>
                      <div className='col-8 text-end'>
                        IGST @ {bookingData.taxRate}%
                      </div>
                      <div className='col-4 text-end'>
                        {(parseFloat(TaxAmount)).toLocaleString("en-US", { style: "currency", currency: "INR" })}
                      </div>
                    </div>
                  </div>
                  :
                  <div className='mt-2'>
                    <div className='row'>
                      <div className='col-8 text-end'>
                        SGST @ {parseFloat(bookingData.taxRate) / 2}%
                      </div>
                      <div className='col-4 text-end'>
                        {(parseFloat(TaxAmount) / 2).toLocaleString("en-US", { style: "currency", currency: "INR" })}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-8 text-end'>
                        CGST @ {parseFloat(bookingData.taxRate) / 2}%
                      </div>
                      <div className='col-4 text-end'>
                        {(parseFloat(TaxAmount) / 2).toLocaleString("en-US", { style: "currency", currency: "INR" })}
                      </div>
                    </div>
                  </div>
              }
              <div className='mt-4 d-flex align-items-center justify-content-between border-top pt-3'>
                <h4 className='fw-bold'>
                  Total Amount
                </h4>
                <h4 className='fw-bold'>
                  {parseFloat(TotalAmount).toLocaleString("en-US", { style: "currency", currency: "INR" })}
                </h4>
              </div>
              <div className='mt-0 d-flex justify-content-between'>
                <div className='col-4'>
                  <span className='text-muted'>In Words</span>
                </div>
                <div className='col-8 text-end'>
                  {AmountInWords}
                </div>
              </div>

              <div className='mt-5 d-flex align-items-center justify-content-end'>
                <h6 className='mb-0'>
                  Authorized signatory
                </h6>
              </div>
              <div className='mt-3 d-flex align-items-center justify-content-end'>
                <div className='w-50 py-5 border rounded' />
              </div>
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
}

export default BookingForm;
